export default __webpack_public_path__ + "static/media/banner-trabalhe-consco.ebb4d39c.png";